import React from 'react';
import { Container } from '@mantine/core';
import { useParams } from 'react-router-dom';
import { ErrorDisplay } from '../components/common/ErrorDisplay';
import PublicItinerary from '../components/trips/PublicItinerary';
import { errorHandler } from '../services/utils/errorHandler';

export function PublicItineraryRoute() {
  const { shareToken } = useParams<{ shareToken: string }>();
  if (!shareToken) {
    const displayError = errorHandler.processError(
      new Error('Invalid or missing share link.')
    );
    return (
      <Container size="lg" mt="xl" data-cy="public-itinerary">
        <ErrorDisplay error={displayError} />
      </Container>
    );
  }
  return <PublicItinerary shareToken={shareToken} />;
}
